<template>
    <div class="tab-text">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Google Tag Manager ID</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <!-- {{ form.gtmid? form.gtmid: '-' }} -->
                <vs-input
                    class="w-full"
                    v-model="form.gtmid"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Google Analytics ID</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    You can get this from the Google Analytics account. For enhanced tracking, please turn on Ecommerce Tracking in Google Analytics.
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.gaid"
                    placeholder="Eg., UA-12345678-2"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Facebook Pixel ID</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    You can get this from the Facebook Pixel code
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.fbpid"
                    placeholder="Eg., 1696938513929033"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Adwords ID</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    You can get this from the Google Adwords tracking code
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.awcid"
                    placeholder="Eg., AW-123456789"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Adwords Label</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    You can get this from the Google Adwords tracking code
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.awclabel"
                    placeholder="Eg., OFWIFPDxlnxQrqfXiwD"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Custom Code</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Added to the HTML at the bottom of the page
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                    style="display: block"
                    class="w-full"
                    v-model="form.code_footer"
                />
            </div>
        </div>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";

export default {
    props: [ 'form', 'e' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            timezones: timezones,
            showSellerCancel: false
        }
    },
    methods: {
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            if (path) {
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(res => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                    });
            }
        },
        canceled() {
            this.$router.push('/sellers')
        }
    },
    mounted() {
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false;
    }
    
};
</script>
